var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"tw-text-2xl tw-font-bold tw-text-primary-50",class:_vm.textColor},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }